export {default as PeopleToContactDataProvider} from './PeopleToContactDataProvider.connect';
